import PropTypes from "prop-types";
import { useSelector } from "react-redux";

import { getVertical } from "../../selectors";

export const BaseVerticalCheck = ({ vertical, children }) => {
	const currentVertical = useSelector(getVertical);
	const isVerticalMatch = Array.isArray(vertical)
		? vertical.includes(currentVertical)
		: vertical === currentVertical;
	if (!isVerticalMatch) return null;

	return children;
};

BaseVerticalCheck.propTypes = {
	vertical: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.arrayOf(PropTypes.string),
	]).isRequired,
	children: PropTypes.node.isRequired,
};
